import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http'
import { EventEmitter, Injectable } from '@angular/core'
import { Observable, shareReplay, map, switchMap, from, of } from 'rxjs'
import { environment } from '../../../environments/environment'

import {cnpj, cpf} from 'cpf-cnpj-validator'
import { TelefonePipe } from 'src/app/shared/pipes/telefone.pipe'
import {VehicleModel, VehicleRequest, VehiclesParams} from "./vehicle";
import {CustomerModel} from "../customer/customer";
import { ServiceOrder } from '../service-order/service-order';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  constructor(
    private _httpClient: HttpClient,
    private _phonePipe: TelefonePipe
  ) {}
  private url = environment.apiUrl + '/veiculos'

  private VehicleList$: Observable<VehicleRequest> | null = null

  public VehicleToEdit: VehicleModel = {} as VehicleModel
  public VehicleToDelete: string = ''

  public totalVehicles: number = 0

  public VehicleListEventEmitter: EventEmitter<VehicleRequest> =
    new EventEmitter()

  public clearVehicleCache() {
    this.VehicleList$ = null
    this.getAllVehicles()
  }

  /** Dados do veículo pela placa, usados para preencher o formulário. */
  public consultarPlaca(placa: string): Observable<any> {
    return this._httpClient.get<any>(`${this.url}/placa/${placa}`)
  }

  public getAllVehicles(objParams?:VehiclesParams) {

    if(objParams) {

      let params = new HttpParams()
        .set('page', (objParams.page || 1).toString())
        .set('page_size', (objParams.page_size || 10).toString())
      
      if (objParams.term) {
        params = params.set('term', objParams.term)
      }
      if (objParams.filter && objParams.filter.length > 0) {
        params = params.set('tags', objParams.filter.join(","))
      }
      if (objParams.only_oon) {
        params = params.set('only_oon', 'true')
      }

      this.VehicleList$ = this._httpClient
      .get<VehicleRequest>(this.url, {params})
      .pipe(
        map((data) => this.formatVehicles(data)),
        shareReplay(1)
      )

    }else{

      const params = {
        page: 1,
        page_size: 10
      }

      this.VehicleList$ = this._httpClient
      .get<VehicleRequest>(this.url, {params})
      .pipe(
        map((data) => this.formatVehicles(data)),
        shareReplay(1)
      )
    }

    this.VehicleList$.subscribe((data) => {
      this.VehicleListEventEmitter.emit(data)
    })
  }

  private formatVehicles(request: VehicleRequest): VehicleRequest {
    const newListVehicles: VehicleModel[] = []

    request.results.map((element) => {
      if (element) {
        const newVehicle: VehicleModel = {
          ...element
        }
        newListVehicles.push(newVehicle)
      }
    })


    request.results = newListVehicles

    return request
  }

  public saveNewVehicle(
    vehicle: VehicleModel
  ): Observable<VehicleModel> {
    return this._httpClient.post<VehicleModel>(this.url, vehicle)
  }

  public updateVehicle(
    id: string,
    vehicle: VehicleModel
  ): Observable<VehicleModel> {
    return this._httpClient.patch<VehicleModel>(
      `${this.url}/${id}`,
      vehicle
    )
  }

  public deleteVehicle(id: string) {
    return this._httpClient.delete(`${this.url}/${id}`)
  }

  public getFullListVehicles(): Observable<any> {

    return this._httpClient
    .get<VehicleRequest>(this.url +'/lista',)
  }

  public getServiceOrdersVehicle (id: number | null): Observable<ServiceOrder[]> {    
    return this._httpClient.get<ServiceOrder[]>(`${this.url}/service-orders/${id}`);
  }

  public getFipeMarcas(tipo: 'carros'|'motos'|'caminhoes' = 'carros', q: string = '', limit: number = 200): Observable<any> {
    let params = new HttpParams().set('tipo', tipo)
    if (q) params = params.set('q', q)
    params = params.set('limit', limit)
    return this._httpClient.get<any>(`${this.url}/fipe/marcas`, { params })
  }

  public getFipeModelos(codigoMarca: string, tipo: 'carros'|'motos'|'caminhoes' = 'carros', q: string = '', limit: number = 200): Observable<any> {
    let params = new HttpParams().set('tipo', tipo)
    if (q) params = params.set('q', q)
    params = params.set('limit', limit)
    return this._httpClient.get<any>(`${this.url}/fipe/modelos/${codigoMarca}`, { params })
  }

  public getFipeAnos(codigoMarca: string, codigoModelo: string, tipo: 'carros'|'motos'|'caminhoes' = 'carros', q: string = '', limit: number = 200): Observable<any> {
    let params = new HttpParams().set('tipo', tipo)
    if (q) params = params.set('q', q)
    params = params.set('limit', limit)
    return this._httpClient.get<any>(`${this.url}/fipe/anos/${codigoMarca}/${codigoModelo}`, { params })
  }

  public getFipeValor(codigoMarca: string, codigoModelo: string, codigoAno: string, tipo: 'carros'|'motos'|'caminhoes' = 'carros'): Observable<any> {
    const params = new HttpParams()
      .set('tipo', tipo)
      .set('marca', codigoMarca)
      .set('modelo', codigoModelo)
      .set('ano', codigoAno)
    return this._httpClient.get<any>(`${this.url}/fipe/valor`, { params })
  }

  public resolverNomesFipe(
    tipo: 'carros'|'motos'|'caminhoes',
    codigoMarca?: string,
    codigoModelo?: string,
    codigoAno?: string
  ): Observable<any> {
    let params = new HttpParams().set('tipo', tipo)
    if (codigoMarca) params = params.set('codigo_marca', codigoMarca)
    if (codigoModelo) params = params.set('codigo_modelo', codigoModelo)
    if (codigoAno) params = params.set('codigo_ano', codigoAno)
    return this._httpClient.get<any>(`${this.url}/fipe/resolver-nomes`, { params })
  }

  public exportVehicles(params?: any) {
    let httpParams = new HttpParams();
    if (params){
      Object.keys(params).forEach(key => {
        const v = params[key];
        if (v !== null && v !== undefined && v !== ''){
          httpParams = httpParams.set(key, v);
        }
      });
    }
    return this._httpClient.get(`${this.url}/export`, { params: httpParams, responseType: 'blob', observe: 'response' as const })
      .pipe(
        switchMap((response) => {
          const contentType = response.headers.get('content-type') || '';
          // Se o Lambda retornou JSON com base64 (padrão Traccar)
          if (contentType.includes('application/json') && response.body) {
            return from(response.body.text()).pipe(
              map((text) => {
                try {
                  const json = JSON.parse(text as unknown as string);
                  if (json?.data && json?.type === 'base64') {
                    const binaryString = atob(json.data);
                    const bytes = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                      bytes[i] = binaryString.charCodeAt(i);
                    }
                    const blob = new Blob([bytes], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    return new HttpResponse<Blob>({
                      body: blob,
                      headers: response.headers,
                      status: response.status,
                      statusText: response.statusText,
                      url: response.url || undefined
                    });
                  }
                } catch (_) {
                  // queda para retorno original
                }
                return response;
              })
            );
          }
          return of(response);
        })
      )
  }

  public getVehiclesWithProduct(params?: {
    page?: number
    page_size?: number
    limit?: number
    filter_type?: string
    filter_value?: string
  }): Observable<VehicleWithProductResponse> {
    let httpParams = new HttpParams()
    
    if (params) {
      if (params.page) httpParams = httpParams.set('page', params.page.toString())
      if (params.page_size) httpParams = httpParams.set('page_size', params.page_size.toString())
      if (params.limit) httpParams = httpParams.set('limit', params.limit.toString())
      if (params.filter_type) httpParams = httpParams.set('filter_type', params.filter_type)
      if (params.filter_value) httpParams = httpParams.set('filter_value', params.filter_value)
    }
    
    // Adicionar header para desabilitar loading global
    const headers = { 'X-Skip-Loader': 'true' }
    
    return this._httpClient.get<VehicleWithProductResponse>(`${this.url}/links`, { 
      params: httpParams,
      headers: headers
    })
  }

  public exportVehiclesWithProduct(params?: any) {
    return this.downloadFile('/links/export', params)
  }

  public downloadLinkImportTemplate(format: 'xlsx' | 'csv' = 'xlsx') {
    return this.downloadFile('/links/import/template', { format })
  }

  public downloadLinkImportReport(jobId: string, format: 'xlsx' | 'csv' = 'xlsx') {
    return this.downloadFile(`/links/import/${jobId}/report`, { format })
  }

  public importVehicleLinks(file: File): Observable<VehicleLinkImportJob> {
    const formData = new FormData()
    formData.append('file', file)
    return this._httpClient.post<VehicleLinkImportJob>(`${this.url}/links/import`, formData)
  }

  public getLinkImportStatus(jobId: string): Observable<VehicleLinkImportJob> {
    return this._httpClient.get<VehicleLinkImportJob>(`${this.url}/links/import/${jobId}`, {
      headers: { 'X-Skip-Loader': 'true' }
    })
  }

  private downloadFile(path: string, params?: any) {
    let httpParams = new HttpParams();
    if (params){
      Object.keys(params).forEach(key => {
        const v = params[key];
        if (v !== null && v !== undefined && v !== ''){
          httpParams = httpParams.set(key, v);
        }
      });
    }
    return this._httpClient.get(`${this.url}${path}`, { params: httpParams, responseType: 'blob', observe: 'response' as const })
      .pipe(
        switchMap((response) => {
          const contentType = response.headers.get('content-type') || '';
          // Se o Lambda retornou JSON com base64 (padrão Traccar)
          if (contentType.includes('application/json') && response.body) {
            return from(response.body.text()).pipe(
              map((text) => {
                try {
                  const json = JSON.parse(text as unknown as string);
                  if (json?.data && json?.type === 'base64') {
                    const binaryString = atob(json.data);
                    const bytes = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                      bytes[i] = binaryString.charCodeAt(i);
                    }
                    const blob = new Blob([bytes], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    return new HttpResponse<Blob>({
                      body: blob,
                      headers: response.headers,
                      status: response.status,
                      statusText: response.statusText,
                      url: response.url || undefined
                    });
                  }
                } catch (_) {
                  // queda para retorno original
                }
                return response;
              })
            );
          }
          return of(response);
        })
      )
  }

  /** Abre o pedido de cancelamento do contrato; o owner decide. */
  public unlinkVehicle(vehicleId: number): Observable<any> {
    return this._httpClient.patch<any>(`${this.url}/${vehicleId}/unlink`, {})
  }

  public activateOon(vehicleId: number): Observable<any> {
    return this._httpClient.post<any>(`${this.url}/${vehicleId}/ativar-oon`, {})
  }
}

export interface VehicleLinkImportError {
  linha: number
  placa: string
  cpf_cnpj: string
  produto_id: string
  motivo: string
}

export interface VehicleLinkImportJob {
  job_id: string
  filename: string | null
  status: 'pending' | 'processing' | 'done' | 'error'
  total: number
  success: number
  failed: number
  processed: number
  pending: number
  errors: VehicleLinkImportError[]
  error_msg: string | null
  created_at: string
  updated_at: string
}

export interface VehicleProductLinkInfo {
  id: number
  status: 'PENDING' | 'APPROVED' | 'REJECTED'
  /** Situação que a tela mostra: são três */
  situation: 'PENDING' | 'APPROVED' | 'REJECTED'
  // Contrato que este substitui: quem tem é endosso, quem não tem nasceu na criação
  substitui_id: number | null
  ended_reason: 'UNLINKED' | 'REJECTED' | 'SUBSTITUIDO' | null
  /** Contrato que está valendo. Só ele pode receber um pedido de cancelamento. */
  active: boolean
  reason: string | null
  created_by_name: string | null
  decided_by_name: string | null
  decided_at: string | null
  created_at: string
}

export interface SeguroCoberturaInfo {
  id: number
  produto_id: number
  nome: string | null
  descricao: string | null
  tipo: string | null
  valor: number | null
}

export interface VehicleWithProduct {
  veiculo: VehicleModel
  link: VehicleProductLinkInfo | null
  // Coberturas do contrato, e a soma do que elas valiam na contratação.
  // Em pedido de cancelamento, são as do contrato que ainda está valendo.
  produtos: SeguroCoberturaInfo[]
  valor_total: number | null
  /** Endosso sem cobertura: é pedido de cancelamento, em qualquer situação */
  cancelamento: boolean
  /** O pedido de cancelamento ainda aguarda decisão, então o contrato segue valendo */
  cancelamento_pendente: boolean
  cliente: {
    id: number
    nome: string
    cpf_cnpj: string
    email: string
    whatsapp?: string
    telefone?: string
  } | null
}

export interface VehicleWithProductResponse {
  results: VehicleWithProduct[]
  total_items: number
  total_pages: number
  current_page: number
  page_size: number
  has_next: boolean
  has_prev: boolean
}
